module.exports = __webpack_public_path__ + "static/media/icons-ic-sms-incoming.d9fc6583.svg";